const endpoint = property => `/api/${property}`;

export default ['api', 'basketApiService', 'basket', 'storeService', function (api, basketApiService, basket, storeService) {
    const save = upgrades => {
        return api.post(`${endpoint(api.property())}/upgrades`, upgrades).then(response => response.data);
    };

    const upgrade = (events) => {
        return callUpgradeApi({
            'guest_items': events.map(event => event.id)
        }, {
            message: 'Error upgrading events'
        });
    };

    const callUpgradeApi = (payload, error) => {
        basket.saving = true;
        const basketCode = storeService.get('basket');
        return api.post(`${endpoint(api.property())}/basket/${basketCode}/upgrade`, payload)
            .then(() => {
                return basketApiService.retrieveBasket(basketCode, true).then(response => {
                    basket.contents = response;

                    basket.saving = false;
                });
            }).catch(() => {
                basket.saving = false;
                throw error;
            });
    };

    return {
        save,
        upgrade
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/upgrade/services/upgrade.service.js